import React from "react";
import "../../shared/styles/shared-styles.css";

const EditErrorModal = (props) => (
  <div data-testid="edit-error-modal" className="shift-modal-container">
    <div className="modal-body">
      <img src="images/roster/edit-shift-error.svg" />
      <span className="modal-body-header">Request failed</span>
      <span className="modal-body-description">{ props.message || "Please try again"}</span>
      <button
        className="modal-button modal-confirm-button"
        onClick={props.cancel}
      >
        OK
      </button>
    </div>
  </div>
);

export default EditErrorModal;
